import { defineComponent, watch } from 'vue'
import NotificationStatusCode from '@/presentation/components/shared/notification-status/notification-status.code';

export default defineComponent({
	setup: () => {
		const code = new NotificationStatusCode();

		watch(code.notificationStatus, code.resetFinalNotificationStatus.bind(code));

		return {
			className: code.className,
			icon: code.icon,
			message: code.message
		};
	}
});
